import React, { Component } from 'react';
// redux
import { connect } from 'react-redux';
import { validateToken, passwordReset } from '../../redux/reducers/auth';
// components
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import ResetPasswordForm from './components/PasswordResetForm';
// utils
import queryString from 'query-string';
import { setAuthData } from '../../utils/authData';
import { toastResponseErrors } from '../../utils/response';
// styles
import styles from './PasswordReset.mod.css';

class PasswordReset extends Component {
  constructor(props) {
    super(props);
    const {
      location: { search }
    } = props;
    const query = queryString.parse(search);
    if (query['reset_password']) {
      this.handlePasswordReset(query);
    }
  }

  handlePasswordReset = query => {
    const { validateToken, history } = this.props;
    setAuthData({
      uid: query.uid,
      'access-token': query.token,
      expiry: query.expiry,
      client: query.client_id,
      'token-type': 'Bearer'
    });
    validateToken()
      .then(() => history.replace(`/password-reset`))
      .catch(toastResponseErrors);
  };

  render() {
    const { history, passwordReset } = this.props;

    return (
      <PageWrapper className={styles.container}>
        <ResetPasswordForm onSubmit={passwordReset} history={history} />
      </PageWrapper>
    );
  }
}

export default connect(
  null,
  { validateToken, passwordReset }
)(PasswordReset);



// WEBPACK FOOTER //
// ./src/containers/PasswordReset/PasswordReset.jsx